@if (showFunds) {
    @if (isPrevidential) {
        <app-basic-table [dataset]="policyFunds" [tableKeys]="tableKeys" (itemSelected)="fundSelected($event)"></app-basic-table>
    } @else {
        <app-assets-table [assets]="policyFunds" [form]="form" [tableKeys]="tableKeys" [isReadOnly]="isReadOnly" (emitFunds)="readFunds($event)"></app-assets-table>
    }
}

<div class="d-flex justify-content-start mt-4">
    @if (operationId !== 'INT_008') {
        <h6>Totale importo disinvestimenti: <span class="status-ko">{{ totalDisinvestmentAmount | currency:'EUR' }}</span></h6>
    }
</div>
